import React, { PropsWithChildren } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Select, {
  components as componentContent,
  GroupTypeBase,
  ValueContainerProps,
} from 'react-select';
import { FormGroupSelectProps } from 'Components/Common/Form/form';
import { Search as IconSearch } from 'react-bootstrap-icons';
import { ISelect } from 'Types/Common';
import MessageError from 'Components/Common/MessageError';

export default function FormGroupSelect(props: FormGroupSelectProps): JSX.Element {
  const {
    label,
    classLabel,
    options,
    onChange,
    defaultValue,
    classNameSlc,
    placeholder,
    errorMessage,
    labelMd,
    colMd,
    colLg,
    labelLg,
    rowClass,
    colClass,
    isMulti,
    register,
    disabled = false,
    isReview = false,
    isSearch,
  } = props;

  const ValueContainer = ({
    children,
    ...props
  }: PropsWithChildren<ValueContainerProps<ISelect, boolean, GroupTypeBase<ISelect>>>) => {
    return (
      componentContent.ValueContainer && (
        <componentContent.ValueContainer {...props}>
          {!!isSearch && (
            <div>
              <IconSearch />
            </div>
          )}
          <div className="ps-1">{children}</div>
        </componentContent.ValueContainer>
      )
    );
  };

  return (
    <Form.Group as={Row} className={rowClass}>
      {label && (
        <Form.Label className={classLabel} column md={labelMd} lg={labelLg}>
          {label}
        </Form.Label>
      )}
      <Col md={colMd} lg={colLg} className={colClass}>
        <Select
          {...register}
          isMulti={isMulti}
          options={options}
          className={`w-100 ${classNameSlc ?? ''}`}
          placeholder={placeholder}
          onChange={!isReview ? onChange : () => null}
          defaultValue={defaultValue}
          components={{
            IndicatorSeparator: () => null,
            ValueContainer,
          }}
          styles={{
            // Fixes the overlapping problem of the component
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 1200,
            }),
          }}
          menuPortalTarget={document.body}
          isDisabled={disabled}
        />
        <MessageError message={errorMessage} />
      </Col>
    </Form.Group>
  );
}
